// ACHTUNG!!! SEO-kritische Komponente, Direkte Importe und Backendaufrufe sollten so gering wie nur möglich gehalten werden


import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { CatalogLogoImgComponent } from "@commonComponents/catalog-logo-img/catalog-logo-img.component";
import { delayHelper } from '@commonHelpers/delay-helper';
import { isNullish } from '@commonHelpers/math-utils';
import { CatalogViewCatalogInformationDto } from '@interfaces/HttpClient/CatalogApiPublicModels';
import { CatalogTreeService } from '@services/catalog-tree.service';
import { CatalogViewService } from '@services/catalog-view.service';
import { TranslationService } from '@services/translation.service';
import { CatalogTreeComponent } from "../catalog-tree/catalog-tree.component";

@Component({
    selector: 'app-catalog-mobile-tree',
    providers: [CatalogTreeService, CatalogViewService],
    templateUrl: './catalog-mobile-tree.component.html',
    styleUrls: ['./catalog-mobile-tree.component.scss'],
    imports: [RouterModule, CatalogTreeComponent, CatalogLogoImgComponent]
})
export class CatalogMobileTreeComponent implements OnInit, OnChanges, OnDestroy {

	public rootLink: string[];
	public categoriesText: string;
	@Input() catalogKey: string;
	@Input() catalog: CatalogViewCatalogInformationDto;
	@Input() highlightedIds: number[];

	constructor(
		private translationService: TranslationService,
		private catalogTreeService: CatalogTreeService,
		private meta: Meta,
		private route: ActivatedRoute
	) {

	}


	ngOnInit(): void {

		delayHelper(() => {
			document.getElementById("preloadContent")?.remove();
		})
	}

	ngOnDestroy(): void {
		this.meta.removeTag("name=robots");
	}
	ngOnChanges(changes: SimpleChanges) {
		if (!isNullish(changes.catalogKey?.currentValue)) {
			this.rootLink = ['/catalog', this.catalogKey];
			if (!isNullish(this.highlightedIds)) {
				this.rootLink.push("search");
			}
			this.catalogTreeService.setKey(this.catalogKey);
		}
		if (!isNullish(changes.catalog?.currentValue)) {
			this.categoriesText = Object.keys(this.catalog.categoryResourceKeys)
				.map(categoryResourceKey => this.catalog.categoryResourceKeys[categoryResourceKey]
					.map(resourceKey => this.translationService.getByKey(resourceKey))
					.join(", ")).join(" | ");
		}
	}



}
